/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { Offcanvas, Spinner } from 'react-bootstrap'
import { RiAddLargeLine, RiArrowRightSLine, RiCloseLine, RiLogoutBoxRLine } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux'
import { setCheckInData, setCheckInStatus } from '../../../redux/appDataSlice'
import { decryptData } from '../../../../utils/api/encrypted'
import ApiFunction from '../../../../utils/api/apiFuntions'
import PLACE_PLACEHOLDER from '../../../../utils/placePlaceholder'

const CheckInManage = ({ show, hide, checkInShow, successDrawer }) => {

    const [loading, setLoading] = useState(false);
    const [checkoutLoading, setCheckoutLoading] = useState(false);
    const [error, setError] = useState('');
    const [placeImageUrl, setPlaceImageUrl] = useState(PLACE_PLACEHOLDER);
    const [imageLoading, setImageLoading] = useState(false);
    const [imageError, setImageError] = useState(false);

    const dispatch = useDispatch();
    const RemainingTime = useSelector(state => state.appData?.checkInTime);
    const checkInData = useSelector(state => state?.appData?.checkInData);
    const place_id = checkInData?.place_id;
    const placeName = checkInData?.place_name || checkInData?.location?.name || '';
    const { post } = ApiFunction();
    const encryptedToken = useSelector(state => state?.appData?.userToken);
    const userToken = decryptData(encryptedToken);

    const clearCheckInStorage = () => {
        localStorage.removeItem('checkInLat');
        localStorage.removeItem('checkInLong');
        localStorage.removeItem('checkInData');
        localStorage.removeItem('checkInType');
        localStorage.removeItem('checkInPlaceName');
        localStorage.removeItem('checkin_data_persistent');
        localStorage.removeItem('checkin_status_persistent');
    };

    useEffect(() => {
        const fetchPlaceImage = async () => {
            setPlaceImageUrl(PLACE_PLACEHOLDER);
            setImageError(false);

            if (!place_id || place_id === 'current' || !window.google?.maps?.places) {
                return;
            }

            setImageLoading(true);

            try {
                const mapDiv = document.createElement('div');
                const map = new window.google.maps.Map(mapDiv);
                const service = new window.google.maps.places.PlacesService(map);

                service.getDetails({ placeId: place_id, fields: ['photos', 'name'] }, (place, status) => {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK && place?.photos?.length > 0) {
                        setPlaceImageUrl(place.photos[0].getUrl({ maxWidth: 200, maxHeight: 200 }));
                    }
                    setImageLoading(false);
                });
            } catch (err) {
                console.error('Error fetching place image:', err);
                setImageLoading(false);
            }
        };

        if (place_id && place_id !== 'current') {
            fetchPlaceImage();
        }
    }, [place_id]);

    const handleImageError = () => {
        if (!imageError) {
            setImageError(true);
            setPlaceImageUrl(PLACE_PLACEHOLDER);
        }
    };

    const handleCheckoutAndCheckIn = () => {
        hide();
        if (checkInShow) {
            setTimeout(() => {
                checkInShow(true);
            }, 300);
        }
    }

    const handleCheckOut = async () => {
        setCheckoutLoading(true);
        setError('');
        const checkInId = checkInData?.checkInId;
        if (!checkInId) {
            setError('Missing check-in id. Please refresh and try again.');
            setCheckoutLoading(false);
            return;
        }

        const currentTime = new Date().toISOString();
        const apiData = new FormData();
        apiData.append('type', 'update_data');
        apiData.append('user_id', userToken);
        apiData.append('id', checkInId);
        apiData.append('table_name', 'check_in');
        apiData.append('checkout_time', currentTime);
        apiData.append('checkout_type', 'user');

        try {
            const res = await post('', apiData);
            if (res?.result) {
                const nameForComplete = placeName;
                dispatch(setCheckInStatus(false));
                dispatch(setCheckInData({}));
                clearCheckInStorage();
                hide();
                if (successDrawer) {
                    setTimeout(() => successDrawer(nameForComplete), 300);
                }
            } else {
                setError(res?.message || 'Checkout failed. Please try again.');
            }
        } catch (err) {
            console.log('checkout error =>', err);
            setError(typeof err === 'string' ? err : (err?.message || 'Checkout failed. Please try again.'));
        } finally {
            setCheckoutLoading(false);
        }
    }

    return (
        <>
            <Offcanvas backdropClassName="blurred-backdrop-offcanvas" show={show} placement='bottom' onHide={hide} className="offcanvas-bottom offcanvasBG">
                <Offcanvas.Header className='relative py-4'>
                    <h1 className='britti fs_18 mb-0 text-center w-full'>Manage Check In</h1>
                    <RiCloseLine onClick={hide} className='w-[24px] h-[24px] absolute right-5' />
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className=' flex flex-col items-center h-100 sm:px-[15px]'>

                        <div className='w-full'>
                            <div className='text-start text-[#525866] fs_16 britti_light mb-[5px]'>You are currently checked in at</div>
                            <div className='checkIn_Detail_card'>
                                <div className="relative">
                                    <img
                                        src={placeImageUrl}
                                        className='rounded-[12px] w-[48px] h-[48px] object-cover'
                                        alt={placeName || 'Place'}
                                        onError={handleImageError}
                                    />
                                    {imageLoading && (
                                        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-[12px]">
                                            <div className="w-4 h-4 border-2 border-[var(--primary)] border-t-transparent rounded-full animate-spin"></div>
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <h1 className='fs_16 britti_bold'>{checkInData?.checkInType} - {placeName || 'Your location'}</h1>
                                    <detail className='txt_grey fs_14'>{RemainingTime} left {(checkInData?.status_text) ? <>- {checkInData?.status_text}</> : ""}</detail>
                                </div>
                            </div>
                        </div>

                        {error ? (
                            <div className='w-full mt-3 text-center text-red-500 fs_14' role="alert">{error}</div>
                        ) : null}

                        <div className='w-full '>
                            <div className='text-start text-[#525866] fs_16 britti mt-[20px] mb-[17px]'>Actions</div>
                            <button 
                                className='border border-[#E1E4EA] px-[12px] py-[18px] rounded-xl bg-[#fff] flex gap-[8px] items-center justify-between w-full cursor-pointer hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
                                onClick={handleCheckoutAndCheckIn}
                                disabled={loading || checkoutLoading}
                            >
                                <div className='flex gap-[8px] items-center'>
                                    <div className='flex items-center justify-center w-[40px] h-[40px] bg-[#EBF1FF] rounded-full mb-2'>
                                        {loading ? (
                                            <Spinner size="sm" animation="border" variant="primary" />
                                        ) : (
                                            <RiAddLargeLine className='w-[20px] h-[20px] text-[#335CFF]' />
                                        )}
                                    </div>
                                    <div>
                                        <h1 className='fs_16 britti_bold mb-[3px] text-start'>Check In Somewhere Else</h1>
                                        <detail className='txt_grey fs_14 text-[#525866]'>End your check-in and start a new one</detail>
                                    </div>
                                </div>
                                <RiArrowRightSLine className='w-[30px] h-[22px] text-[#525866] ms-2' />
                            </button>

                            <button 
                                className='border border-[#E1E4EA] px-[12px] py-[18px] rounded-xl mt-[12px] bg-[#fff] flex gap-[8px] items-center justify-between w-full cursor-pointer hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
                                onClick={handleCheckOut}
                                disabled={loading || checkoutLoading}
                            >
                                <div className='flex gap-[8px] items-center'>
                                    <div className='flex items-center justify-center w-[40px] h-[40px] bg-[#FFF3EB] rounded-full mb-2'>
                                        {checkoutLoading ? (
                                            <Spinner size="sm" animation="border" variant="warning" />
                                        ) : (
                                            <RiLogoutBoxRLine className='w-[20px] h-[20px] text-[#FA7319]' />
                                        )}
                                    </div>
                                    <div >
                                        <h1 className='fs_16 britti_bold mb-[3px] text-start'>End Check In</h1>
                                        <detail className='txt_grey fs_14 text-[#525866]'>Remove visibility from map and chat.</detail>
                                    </div>
                                </div>
                                <RiArrowRightSLine className='w-[30px] h-[22px] text-[#525866] ms-2' />
                            </button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default CheckInManage
